/**
 * @author atul.silori <atul.silori@314ecorp.com>
 * @description ViewClaimStatusChecks
 */
import { Protect } from '@icon-park/react';
import { Button as AntButton, ButtonProps } from 'antd';

import { SUCCESS_REQUEST_CODE } from 'app-constants/eligibility';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { claimStatusInputFormPath } from 'utils/router';

/**
 * ViewClaimStatusChecks
 */
const ViewClaimStatusChecks: React.FC<ButtonProps & { selectedPayers: Payers.ISelectedPayer[]; data: EligibilityResponse.IModel }> = (
	props,
) => {
	const { data, selectedPayers, onClick, ...restProps } = props;
	const payer = _.find(selectedPayers, { id: data?.requestInfo?.tenantpayerId });

	if (payer?.isClaimStatus && data?.requestStatus === SUCCESS_REQUEST_CODE) {
		return (
			<Link to={claimStatusInputFormPath(data?.responseId)}>
				<AntButton type='primary' key='view-claim-status-response' onClick={onClick} {...restProps} icon={<Protect />}>
					{'Check Claim Status'}
				</AntButton>
			</Link>
		);
	}

	return null;
};

export default ViewClaimStatusChecks;
